module.exports = __webpack_public_path__ + "img/a5a08d7981d28f989c4c1bffbe28b323.svg";